import React from 'react';
import { Section } from './ui/Section';
export function SalesFooter() {
  return <footer className="bg-warm-section border-t border-warm-border py-12 text-center" data-id="element-134">
      <div className="max-w-2xl mx-auto px-4" data-id="element-135">
        <p className="font-serif font-bold text-xl mb-2 text-text-primary" data-id="element-136">
          Monotributista en Calma
        </p>
        <p className="text-text-secondary text-sm" data-id="element-137">
          Hecho para monotributistas argentinos que quieren dormir tranquilos.
        </p>
        <div className="mt-8 text-xs text-text-secondary opacity-60" data-id="element-138">
          &copy; {new Date().getFullYear()} Monotributista en Calma. Todos los
          derechos reservados.
        </div>
      </div>
    </footer>;
}